module.exports = __webpack_public_path__ + "img/menu-icon.8723dbe5.svg";